import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import { registerAndAutoUpdate } from './lib/pwa/swUpdater'
import { isFinanceHost } from './lib/hosts'

// Service worker registration is owned entirely by swUpdater, which enforces:
//   - production builds only
//   - top-level window only (never inside an iframe)
//   - books.hibane.ai only (preview / lovable.app / localhost are blocked)
// In every other context registerAndAutoUpdate unregisters any stale SWs.
const inIframe = (() => {
  try { return window.self !== window.top; } catch { return true; }
})();

if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD && isFinanceHost() && !inIframe) {
    window.addEventListener('load', () => {
      registerAndAutoUpdate('/finance-sw.js', { scope: '/' });
    });
  } else {
    // Unregister any stale workers in dev / preview / iframe contexts.
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) registration.unregister();
    }).catch(() => { /* noop */ });
  }
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
